import { useEffect } from "react";

/**
 * Hook that automatically scrolls horizontally to the activeElement whenever its reference changes
 *
 * @param {string | number | object} activeElement  element's unique attribute
 * @param {function} getElementFromDOM  function for retrieving element from DOM.
 *                                      Must be wrapped with UseCallback hook since
 *                                      it is used as a dependency here
 */
const useScrollHorizontallyToElement = (activeElement, getElementFromDOM) => {
  useEffect(() => {
    if (activeElement && getElementFromDOM) {
      const el = getElementFromDOM(activeElement);

      if (el) {
        scrollTo(el);
      }
    }
  }, [activeElement, getElementFromDOM]);

  const scrollTo = (el) => {
    const elRight = el.offsetLeft + el.offsetWidth;
    const elLeft = el.offsetLeft;

    const elParentRight = el.parentNode.offsetLeft + el.parentNode.offsetWidth;
    const elParentLeft = el.parentNode.offsetLeft;

    // check if right side of the element is not in view
    if (elRight > elParentRight + el.parentNode.scrollLeft) {
      el.parentNode.scrollLeft = elRight - elParentRight;
    }

    // check if left side of the element is not in view
    else if (elLeft < elParentLeft + el.parentNode.scrollLeft) {
      el.parentNode.scrollLeft = elLeft - elParentLeft;
    }
  };
};

export default useScrollHorizontallyToElement;
